import { graphql, useStaticQuery, } from "gatsby"
import { FormClose } from "grommet-icons"
import React, { useEffect, useState } from "react"
import Apollo from "../../providers/Apollo"
import FormComponent from "./Form"
import SpecialOfferComponent from "./SpecialOffer"
import * as s from "./index.styles"

interface IProps {
  dismiss: () => void
}

type Step = "details" | "special-offer"

const ExitIntentModal = (props: IProps) => {
  const [step, setStep] = useState<Step>("details")

  const { willLogoImage, bundle2Image } = useStaticQuery(graphql`
    {
      willLogoImage: file(relativePath: { eq: "will-logo-purple.png" }) {
        childImageSharp {
          gatsbyImageData(placeholder: NONE, width: 120)
        }
      }
      bundle2Image: file(relativePath: { eq: "bundle-2xl.png" }) {
        childImageSharp {
          gatsbyImageData(placeholder: BLURRED, width: 270)
        }
      }
    }
  `)

  useEffect(() => {
    document.body.style.overflow = "hidden"
    return () => {
      document.body.style.overflow = "auto"
    }
  }, [])

  return (
    <>
      <s.Overlay onClick={props.dismiss}>
        <s.Wrapper onClick={e => e.stopPropagation()}>
          <s.QuitButton onClick={props.dismiss}>
            <FormClose color="#fff" size="28px" />
          </s.QuitButton>
          {step === "details" && (
            <FormComponent
              bundle2Image={bundle2Image}
              logoImage={willLogoImage}
              onComplete={() => setStep("special-offer")}
            />
          )}
          {step === "special-offer" && (
            <SpecialOfferComponent
              discountLabel="Get 50% Off"
              onClaim={() => {
                props.dismiss()
              }}
              onSkip={() => props.dismiss()}
            />
          )}
        </s.Wrapper>
      </s.Overlay>
    </>
  )
}

export default (props: IProps) => (
  <Apollo>
    <ExitIntentModal {...props} />
  </Apollo>
)
